import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const FloatingNotification = () => {
  const product = 'Megapack Saberes Ancestrales · 5 volúmenes 🌿';
  const buyers = [{
    name: 'Valentina R.',
    location: 'Guadalajara',
    product,
    time: 'hace 2 minutos'
  }, {
    name: 'Camila S.',
    location: 'Bogotá',
    product,
    time: 'hace 5 minutos'
  }, {
    name: 'Diego M.',
    location: 'Lima',
    product,
    time: 'hace 8 minutos'
  }, {
    name: 'María G.',
    location: 'Ciudad de México',
    product,
    time: 'hace 14 minutos'
  }, {
    name: 'Roberto G.',
    location: 'Santiago',
    product,
    time: 'hace 22 minutos'
  }, {
    name: 'Valentina P.',
    location: 'Montevideo',
    product,
    time: 'hace 31 minutos'
  }];
  const [isVisible, setIsVisible] = useState(false);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setIndex(i => (i + 1) % buyers.length);
        setIsVisible(true);
      }, 1000);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  const notificationData = buyers[index];
  return <AnimatePresence data-id="element-88" data-mp="1hxr8aje1r5c0">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm" data-id="element-89" data-mp="1hyu0cun3vdti">
          <div className="glass-panel bg-white/95 p-4 rounded-2xl shadow-xl border-brand-purple/30 flex items-start space-x-4 backdrop-blur-md" data-id="element-90" data-mp="z79kmt82mzxi">
            <div className="bg-brand-purple/10 p-2 rounded-full shrink-0 mt-1" data-id="element-91" data-mp="u8ghnuqeurbl">
              <CheckCircle2 className="w-5 h-5 text-brand-purple" data-id="element-92" data-mp="kj9n7872297x" />
            </div>
            <div data-id="element-93" data-mp="omperq49pjdr">
              <div className="text-xs text-brand-text/60 mb-1 flex items-center" data-id="element-94" data-mp="on7ljgok3fzx">
                🔔 Compra verificada • {notificationData.time}
              </div>
              <div className="text-sm font-medium text-brand-text mb-1" data-id="element-95" data-mp="fkg8xdjy2e6p">
                <span className="font-bold" data-id="element-96" data-mp="13ak8n9u0htsf">{notificationData.name}</span> de{' '}
                {notificationData.location} compró
              </div>
              <div className="text-sm text-brand-purple font-bold" data-id="element-97" data-mp="188c248ab1nyq">
                {notificationData.product}
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};